import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import Membership from "@components/Membership";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const UserMembershipsPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const brand = whiteLabel?.brand_name;

    return (
        <VersionedLayout>
            <Helmet>
                <title>{`Memberships | ${brand}`}</title>
                <meta name="keywords" content={`Memberships | ${brand}`} />
                <meta
                    name="description"
                    content={`Keep track of your membership
                information & history through your ${brand} membership page.`}
                />
                <link rel="canonical" href={`${window.location.protocol}//${window.location.host}/user/membership`} />
            </Helmet>
            <h1 className="movie-club__section-title">Memberships</h1>
            <Membership />
        </VersionedLayout>
    );
};

export default UserMembershipsPage;
